/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  BRAND_NAME: 'Sula Vineyards Ltd.',
  SIGNER_PK:
    '-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCCeNvL99QSY0BGtgL751diUNFS\n1D4D25yjFYaTF7Ru93bvVGBFPkVmkIJeZ6oXCm2QTx7ljEkBYHqJTYJqz+LUnuRH\nHF5AGnGKy/3XtQG6CrBGRl2zVS27LP9C4JMOW69u28L5oEVW6qr52aJwuqPH2aF0\nUZpNKvWAZTsQZF7aZwIDAQAB\n-----END PUBLIC KEY-----',
  defaultLoading: {
    image: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.logos/trag.png',
    titleNormalText: 'Loading',
    titleBoldText: 'Page...',
    description: 'This might take few seconds, Please wait !',
  },
  platformSemantics: {
    semantics: {
      holder: 'Users',
      holders: 'Users',
      issuer: 'Organization',
    },
    Holders: {
      title: 'Users',
    },
    HoldersGroups: {
      title: 'Users Group',
    },
    DashboardIssuerAnalysis: {
      title: 'Organization',
    },
  },
};
